import React from 'react';
import Input from '4all-ui/components/Input';
import Button from '4all-ui/components/Button';
import * as styles from '../style';
import withCategories from '../../../../containers/Categories';
import Storage from '../../../../helpers/storage';
import FormLoader from '../../../../components/FormLoader';
import { FormGroup } from '../../../../styles/customComponents';

class CreateCategory extends React.PureComponent {
  state = {
    inputCreateCategory: '',
    showModal: false,
  };

  onClose = () => {
    this.setState({ inputCreateCategory: '', showModal: false });
  };

  onSaveCategory = async e => {
    e.stopPropagation();
    e.preventDefault();

    if (this.state.inputCreateCategory.length === 0) {
      return;
    }

    const data = {
      merchantId: Storage.getLocalStorage('merchant').idUnity,
      name: this.state.inputCreateCategory,
      type: 1,
    };

    this.setState({ showModal: true });
    const newCategory = await this.props.saveCategory(data);

    if (newCategory) {
      this.setState({ inputCreateCategory: '' });
      const data = { ...newCategory, sortOrder: 1 };
      await this.props.sortOrderCategory(data);
      this.props.insertCategoryInProductsList(data);
      this.props.refreshProductsList();
    }
  };

  render() {
    const { productCategories } = this.props;

    return (
      <React.Fragment>
        <FormLoader
          onClose={this.onClose}
          isSubmiting={productCategories.isLoadingSubmit}
          showModal={this.state.showModal}
          error={productCategories.error || {}}
          finishedText={'Categoria cadastrada com sucesso!'}
          loadingText="Salvando Categoria ..."
        />
        <styles.CreateCategory as="form" onSubmit={this.onSaveCategory}>
          <FormGroup>
            <label htmlFor="input-create-category">Criar Categoria</label>
            <Input
              id="input-create-category"
              type="text"
              placeholder="Nome da categoria (ex: bebidas)"
              value={this.state.inputCreateCategory}
              maxLength="45"
              onChange={e => this.setState({ inputCreateCategory: e.target.value })}
            />
          </FormGroup>

          <Button
            onClick={this.onSaveCategory}
            type="submit"
            id="btn-create-category"
            customStyles={{
              alignSelf: 'flex-end',
              flexShrink: 0,
              height: 45,
              marginLeft: 5,
              width: 72,
            }}
          >
            Criar
          </Button>
        </styles.CreateCategory>
      </React.Fragment>
    );
  }
}

export default withCategories(CreateCategory);



// WEBPACK FOOTER //
// ./src/screens/Product/ProductsSecondaryActions/CreateCategory/index.js